import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IsLoggedGuard, IsProGuard } from './is-logged.guard';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { PagesComponent } from './pages/pages.component';
import { GamesComponent } from './games/games.component';
import { GameComponent } from './game/game.component';
import { MyOrdersComponent } from './my-orders/my-orders.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { OrderComponent } from './order/order.component';
import { OffresComponent } from './offres/offres.component';
import { NewslettersComponent } from './newsletters/newsletters.component';
import { RdvComponent } from './rdv/rdv.component';
import { EditorsComponent } from './editors/editors.component';
import { LandingComponent } from './landing/landing.component';
import { StoresComponent } from './stores/stores.component';
import { SavComponent } from './sav/sav.component';
import { NewsComponent } from './news/news.component';
import { PreordersComponent } from './preorders/preorders.component';
import { ContactComponent } from './contact/contact.component';
import { AdminComponent } from './admin/admin.component';
import { AdminOrderComponent } from './admin/admin-order/admin-order.component';
import { AdminProComponent } from './admin/admin-pro/admin-pro.component';
import { CatalogueComponent } from './catalogue/catalogue.component';
import { EventsComponent } from './events/events.component';
import { BilanRseComponent } from './catalogue/bilan-rse/bilan-rse.component';

const routes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'accueil', component: LandingComponent},
  {path: '', component: HomeComponent, canActivate: [IsLoggedGuard], children: [
    {path: 'pages/:url', component: PagesComponent},
    {path: 'news/:id', component: NewsComponent},
    {path: 'news', component: NewsComponent},
    {path: 'favoris', component: GamesComponent},
    {path: 'sorties', component: GamesComponent},
    {path: 'mon-top', component: GamesComponent, canActivate: [IsProGuard]},
    {path: 'editeur/:id', component: GamesComponent},
    {path: 'editeurs', component: EditorsComponent},
    {path: 'editors', component: EditorsComponent},
    {path: 'boutiques', component: StoresComponent},
    {path: 'games', component: GamesComponent},
    {path: 'gss', component: GamesComponent},
    {path: 'games/:filter', component: GamesComponent},
    {path: 'game/:id', component: GameComponent},
    {path: 'jeux/:id', component: GameComponent},
    {path: 'mon-compte', component: MyAccountComponent, canActivate: [IsProGuard]},
    {path: 'mes-commandes', component: MyOrdersComponent, canActivate: [IsProGuard]},
    {path: 'commande', component: OrderComponent, canActivate: [IsProGuard]},
    {path: 'commande/fast', component: OrderComponent, canActivate: [IsProGuard]},
    {path: 'offres-commerciales', component: OffresComponent, canActivate: [IsProGuard]},
    {path: 'newsletters', component: NewslettersComponent},
    {path: 'newsletters', component: NewslettersComponent},
    {path: 'rendez-vous', component: RdvComponent},
    {path: 'sav', component: SavComponent},
    {path: 'contact', component: ContactComponent},
    {path: 'preorders-essen', component: PreordersComponent},
    {path: 'catalogues', component: CatalogueComponent},
    {path: 'bilan-rse', component: BilanRseComponent},
    {path: 'events', component: EventsComponent},
  ]},
  {path: 'admin/:token', component: AdminComponent, children: [
    {path: 'adminOrder', component: AdminOrderComponent},
    {path: 'adminOrder/:tabIndex', component: AdminOrderComponent},
    {path: 'adminPro', component: AdminProComponent},
  ]},
  {path: '**', redirectTo:''},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
